import { render } from "./KeywordManagement.vue?vue&type=template&id=8d3ee8ba&scoped=true"
import script from "./KeywordManagement.vue?vue&type=script&lang=js"
export * from "./KeywordManagement.vue?vue&type=script&lang=js"

import "./KeywordManagement.vue?vue&type=style&index=0&id=8d3ee8ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d3ee8ba"]])

export default __exports__